import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

const { Link } = ReactRouterDOM as any;

const ThankYouPage: React.FC = () => {
    const orderId = `ORD-${Math.floor(Math.random() * 10000) + 1000}`;

    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 animate-fade-in bg-[#fcfcfc] py-20">
            <div className="bg-green-50 p-8 rounded-full mb-8 animate-bounce-slow">
                <CheckCircle size={64} className="text-green-600" strokeWidth={1.5} />
            </div>
            
            <h1 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6">Dziękujemy za zamówienie</h1>
            
            <div className="max-w-lg mx-auto bg-white p-6 rounded-lg border border-gray-100 shadow-sm mb-8">
                <p className="text-gray-500 mb-2 uppercase tracking-widest text-xs">Numer zamówienia</p>
                <p className="text-2xl font-mono text-black font-bold mb-4">#{orderId}</p>
                <div className="h-px bg-gray-100 w-full mb-4"></div>
                <p className="text-gray-600 text-sm leading-relaxed">
                    Twoja płatność została przyjęta i zweryfikowana pomyślnie. 
                    Potwierdzenie wraz ze szczegółami wysłaliśmy na Twój adres e-mail.
                </p>
            </div>

            <Link 
                to="/" 
                className="group flex items-center gap-2 bg-black text-white px-8 py-4 uppercase tracking-widest text-xs font-bold hover:bg-gray-800 transition-all hover:pr-10 relative"
            >
                Wróć do sklepu 
                <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 absolute right-4 transition-opacity" />
            </Link>
        </div>
    );
};

export default ThankYouPage;